import React, { createContext } from 'react';

interface IProps {
  slug: string;
  contentWindow: HTMLIFrameElement;
  children?: React.ReactNode;
}

export const EditorWindowContext = createContext<IProps | undefined>(undefined);

export const EditorWindow: React.FC<IProps> = ({ children, ...props }) => {
  console.log('EditorWindow', props);
  return (
    <EditorWindowContext.Provider value={{ ...props }}>
      {children}
    </EditorWindowContext.Provider>
  );
};
